import React from 'react';
import { withPrefix } from 'gatsby';
import { Text } from '../../components/Text';
import { Wrapper } from '../../components/Wrapper';
import { Divider } from '../../components/Divider';
import { Subtitle } from '../../components/Text/Subtitle';
import { LastStrongWorldText } from '../../components/Text/LastStrongWorldText';
import { HeroSection } from '../../components/HeroSections/FirstPage';
import { StrongWordTextSection } from '../../components/StrongWordTextSection';
import { Layout } from '../../components/Layout';
import { ImagesWithShadowList } from '../../components/ImagesWithShadowList';
import { Poll } from '../../components/Poll';
import { References } from '../../components/References';
import { HeroContainer } from '../../components/HeroСontainer';
import styles from './MainTemplate.styles';

const MainTemplate = ({
  pageContext: {
    PageData: {
      seo,
      hero,
      text,
      titles,
      images,
      mobileImages,
      imagesWithShadow,
      sectionWithPostFirst,
      sectionWithText,
      sectionWithPostsSecond,
      navigation,
      imagesCommon,
      diagrams,
      references,
    },
  },
  location,
}) => (
  <Layout
    props={seo}
    navigation={navigation}
    locationPathName={location.pathname}
    imagesCommon={imagesCommon}
    logo={imagesCommon.logoHeadAdv}>
    <div className="article" css={styles(hero.backgroundColorFooter)}>
      <HeroContainer propsHero={hero} propsCommon={imagesCommon}>
        <HeroSection props={hero} />
      </HeroContainer>
      <Divider height={8} />
      <Wrapper maxWidth={'840px'} width={'100%'} mobileWidth={'90%'}>
        <Text text={text.first} width={'100%'} />
        <Divider height={4} heightMobile={8} />
        <div className="article__subtitle--yellow">
          <Subtitle
            text={titles.first}
            fontSize={28}
            lineHeight={32}
            maxWidth={'606px'}
            width={'100%'}
            fontWeight={'normal'}
          />
        </div>
      </Wrapper>
      <Divider height={8} />
      <Wrapper maxWidth={'1024px'} width={'100%'} mobileWidth={'100%'}>
        <ImagesWithShadowList images={imagesWithShadow} />
      </Wrapper>
      <Divider height={8} heightMobile={12} />
      <Wrapper maxWidth={'840px'} width={'100%'} mobileWidth={'90%'}>
        {titles.second && (
          <Subtitle
            text={titles.second}
            fontSize={24}
            lineHeight={28}
            maxWidth={'100%'}
            width={'100%'}
            fontWeight={'normal'}
          />
        )}
        <Divider height={4} heightMobile={6} />
        <Text text={text.second} width={'100%'} />
      </Wrapper>
      <Divider height={6} heightMobile={8} />
      <div className="article__posts-block-background article__posts-block-background--small-size" />
      <Wrapper maxWidth={'1024px'} width={'100%'} mobileWidth={'100%'}>
        <div className="article__posts-block-first">
          <StrongWordTextSection
            title={sectionWithPostFirst.title}
            posts={sectionWithPostFirst.posts}
            width={'1024px'}
            height={'339'}
            subtitleWidth={'100%'}
            subtitleMaxWidth={'400px'}
            fontSizeLastWord={72}
            lineHeightLastWord={90}
            marginFirstColumn={{
              top: 63,
              right: 0,
              bottom: 0,
              left: 0,
            }}
            marginSecondColumn={{
              top: 32,
              right: 0,
              bottom: 0,
              left: 16,
            }}
          />
        </div>
      </Wrapper>
      <Divider height={10} heightMobile={8} />
      <Wrapper maxWidth={'840px'} width={'100%'} mobileWidth={'90%'}>
        <Subtitle
          text={titles.third}
          fontSize={24}
          lineHeight={28}
          maxWidth={'100%'}
          width={'100%'}
          fontWeight={'normal'}
        />
        <Divider height={4} heightMobile={6} />
        <Text text={text.third} width={'100%'} />
      </Wrapper>
      <Divider height={6} heightMobile={8} />
      {images && mobileImages && (
        <Wrapper maxWidth={'1024px'} width={'100%'} mobileWidth={'100%'}>
          <img className="article__image-steps" src={withPrefix(images.first)} alt="illustration" />
          <img className="article__image-steps--mobile" src={withPrefix(mobileImages.first)} alt="illustration" />
          <Divider height={6} heightMobile={8} />
        </Wrapper>
      )}
      <Wrapper maxWidth={'840px'} width={'100%'} mobileWidth={'90%'}>
        <Subtitle
          text={titles.fourth}
          fontSize={24}
          lineHeight={28}
          maxWidth={'100%'}
          width={'100%'}
          fontWeight={'normal'}
        />
        <Divider height={4} heightMobile={6} />
        <Text text={text.fourth} width={'100%'} />
        <Divider height={10} heightMobile={10} />
      </Wrapper>
      <Wrapper maxWidth={'1024px'} width={'100%'} mobileWidth={'100%'}>
        <div className="article__posts-text-block">
          <LastStrongWorldText
            content={sectionWithText.title}
            width={'100%'}
            maxWidth={'400px'}
            fontSize={120}
            lineHeight={140}
          />
          <div className="strong-word-section__text-container">
            <Text text={sectionWithText.text} width={'100%'} />
          </div>
        </div>
      </Wrapper>
      <Divider height={10} heightMobile={8} />
      <Poll diagram={diagrams?.first} />
      {diagrams?.second && (
        <>
          <Divider height={12} heightMobile={8} />
          <Poll diagram={diagrams.second} />
        </>
      )}
      <Divider height={8} heightMobile={12} />
      <div className="article__posts-block-background-footer">
        <Wrapper maxWidth={'1024px'} width={'100%'} mobileWidth={'100%'}>
          <div className="article__posts-block-second">
            <StrongWordTextSection
              title={sectionWithPostsSecond.title}
              posts={sectionWithPostsSecond.posts}
              width={'1024px'}
              height={'339'}
              subtitleWidth={'100%'}
              subtitleMaxWidth={'400px'}
              fontSizeLastWord={72}
              lineHeightLastWord={90}
              align-first-column="0 center"
              alignFirstColumnFlexContainer={{
                alignItems: 'flex-start',
                justifyContent: 'center',
              }}
              marginSecondColumn={{
                top: 48,
                right: 0,
                bottom: 0,
                left: 16,
              }}
            />
          </div>
        </Wrapper>
      </div>
      <Divider height={8} />
      <Wrapper maxWidth={'1024px'} width={'100%'} mobileWidth={'100%'}>
        <References references={references} />
      </Wrapper>
    </div>
  </Layout>
);

export default MainTemplate;
